<template>
    <SOSlotCard :card-type="'shadow'">
        <template v-slot:card_head>
            <span
                v-if="biaya.status === 1"
                class="f-regular f-12 f-c-midgrey bg-gray rounded m-d-4"
                style="padding: 2px 4px"
            >
                Menunggu konfirmasi
            </span>
            <div class="d-flex-between-center f-16 f-semi f-c-black m-d-4">
                <div
                    class="m-d-0 f-c-black"
                    v-if="search !== ''"
                    v-html="searchHighlight('Rp ' + formatRupiah(biaya.nominal), search)"
                ></div>
                <div class="m-d-0 f-c-black" v-else>Rp {{ formatRupiah(biaya.nominal) }}</div>
                <img src="@/assets/icons/chevron_right_4.svg" />
            </div>
        </template>
        <template v-slot:card_body>
            <div class="f-regular f-13 f-c-midgrey m-d-2">
                <img src="@/assets/icons/outlet-out-muted.svg" alt="" />
                <span
                    class="f-c-black"
                    v-if="search !== ''"
                    v-html="
                        searchHighlight(
                            biaya.akun_debet !== ''
                                ? biaya.akun_debet + '  •  ' + biaya.related_name
                                : biaya.related_name,
                            search
                        )
                    "
                ></span>
                <span v-else class="m-l-4">{{
                    biaya.akun_debet !== "" ? biaya.akun_debet + "  •  " + biaya.related_name : biaya.related_name
                }}</span>
            </div>
            <div class="f-regular f-13 f-c-midgrey m-d-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.99998 2.66732C5.05446 2.66732 2.66665 5.05513 2.66665 8.00065C2.66665 10.9462 5.05446 13.334 7.99998 13.334C10.9455 13.334 13.3333 10.9462 13.3333 8.00065C13.3333 5.05513 10.9455 2.66732 7.99998 2.66732ZM1.33331 8.00065C1.33331 4.31875 4.31808 1.33398 7.99998 1.33398C11.6819 1.33398 14.6666 4.31875 14.6666 8.00065C14.6666 11.6826 11.6819 14.6673 7.99998 14.6673C4.31808 14.6673 1.33331 11.6826 1.33331 8.00065ZM7.33331 5.33398C7.33331 4.96579 7.63179 4.66732 7.99998 4.66732H8.00665C8.37484 4.66732 8.67331 4.96579 8.67331 5.33398C8.67331 5.70217 8.37484 6.00065 8.00665 6.00065H7.99998C7.63179 6.00065 7.33331 5.70217 7.33331 5.33398ZM6.66665 8.00065C6.66665 7.63246 6.96512 7.33398 7.33331 7.33398H7.99998C8.36817 7.33398 8.66665 7.63246 8.66665 8.00065V10.0007C9.03484 10.0007 9.33331 10.2991 9.33331 10.6673C9.33331 11.0355 9.03484 11.334 8.66665 11.334H7.99998C7.63179 11.334 7.33331 11.0355 7.33331 10.6673V8.66732C6.96512 8.66732 6.66665 8.36884 6.66665 8.00065Z"
                        fill="#C8D0DD"
                    />
                </svg>
                <span class="m-l-4">{{ biaya.item_biaya.biaya_kategori.nama }}</span>
            </div>
            <div class="f-regular f-13 f-c-midgrey m-d-2">Item biaya: {{ biaya.item_biaya.nama }}</div>
            <div class="f-regular f-13 f-c-midgrey m-d-2" v-if="biaya.keterangan">Keterangan: {{ biaya.keterangan }}</div>
            <div class="f-regular f-13 f-c-midgrey m-d-2">tgl permintaan: {{ biaya.waktu_pemakaian_formated }}</div>
        </template>
        <template v-slot:card_footer>
            <div class="row m-0 need-confirm f-12 biaya-outlet-card-footer-bg" v-if="biaya.status === 1">
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + biaya.karyawan, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 nomore" v-else>Oleh {{ biaya.karyawan }}</div>
                <div
                    class="col-md-6 col-sm-6 col-6 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(biaya.created_at_formated, search)"
                ></div>
                <div class="col-md-6 col-sm-6 col-6 p-0 text-right" v-else>({{ biaya.created_at_formated }})</div>
            </div>

            <div class="row m-0 need-confirm f-12 align-items-center" v-else>
                <div
                    class="col-md-4 col-sm-4 col-4 p-0 nomore"
                    v-if="search !== ''"
                    v-html="searchHighlight('Oleh ' + biaya.karyawan, search)"
                ></div>
                <div class="col-md-4 col-sm-4 col-4 p-0 nomore" v-else>Oleh {{ biaya.karyawan }}</div>
                <div
                    class="col-md-5 col-sm-5 col-5 p-0 text-right"
                    v-if="search !== ''"
                    v-html="searchHighlight(biaya.created_at_formated, search)"
                ></div>
                <div class="col-md-5 col-sm-5 col-5 p-0 text-right" v-else>({{ biaya.created_at_formated }})</div>
                <div class="col-md-3 col-sm-3 col-3 p-0 text-right">
                    <span class="badge-tag tg-green" v-if="biaya.status === 2">Disetujui</span>
                    <span class="badge-tag tg-red" v-if="biaya.status === 3">Ditolak</span>
                </div>
            </div>
        </template>
    </SOSlotCard>
</template>

<script>
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

export default {
    name: "CardBiayaOutlet",
    components: {
        SOSlotCard,
    },
    mounted() {
        this.fixCardUI();
    },
    props: {
        biaya: Object,
        search: {
            type: String,
            default: "",
        },
    },
    methods: {
        fixCardUI() {
            setTimeout(() => {
                $(".card").addClass("biaya-outlet-card-fix");
                $(".card-footer").addClass("biaya-outlet-card-footer-fix");
            }, 200);
        },
    },
};
</script>

<style>
.need-confirm {
    padding: 4px 16px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
}

.biaya-outlet-card-footer-bg {
    background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%);
}

.biaya-outlet-card-footer-fix {
    padding: 0 !important;
}

.biaya-outlet-card-fix {
    padding-bottom: 0 !important;
}
</style>
